import { Tooltip } from "@mui/material";

interface CveIdCellProps {
  value: string;
}

const CveIdCellRenderer = (params: CveIdCellProps) => {
  const cveId = params.value;

  if (!cveId) return <span>-</span>;

  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%" }}>
      <Tooltip
        title={cveId}
        arrow
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: "#fff",
              color: "#000",
              boxShadow: 1,
              fontSize: "0.775rem",
            },
          },
          arrow: {
            sx: {
              color: "#fff",
            },
          },
        }}
      >
        <span
          className="ag-bold fs-13"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%",
            display: "inline-block",
            lineHeight: "normal",
          }}
        >
          {cveId}
        </span>
      </Tooltip>
    </div>
  );
};

export default CveIdCellRenderer;
